import { isMobile } from "react-device-detect"
import { Notas, NotasMobile3Solas, NotasPC3Solas } from "../component/Notas"
import { useNavigate } from "react-router"
import { EmpityBox } from "../component/Decoracion"
import { FaWhatsapp } from "react-icons/fa";
import { IoMailOutline } from "react-icons/io5";
import { imagenesAll } from "../asset/bgImg"
import { useState } from "react"  
import bannerDoc from "../asset/img/banerAstrogigix.jpg"
import bannerYT from "../asset/img/bannerYT.jpg"
export const Home =()=>{
  return(
    <>
      {isMobile ? <IsMobileHome/> : <IsPcHome  />}
    </>
  )
}

const IsPcHome =()=>{
  return(
    <main className="d-flex flex-column justify-content-center align-items-center bg-white">
      <header className="d-flex m_header text-white w-100 justify-content-center align-items-center">
        <div className="m_w_80 h-100 d-flex justify-content-center align-items-center d-flex flex-column pe-5 me-5">
            <h1 className=" m_font_primaryss m_nameLogo text-white fw-bold ms-5 ps-4 pe-5"><img className="w-50" src={imagenesAll.h1Logo} alt="ASTROGIGIX" /></h1>
            <span className="fs-5  m_font_primaryss me-4 pe-4">Astrología para ayudarnos a mirar el <br></br> cielo que llevamos dentro.</span>
        </div>
      </header>
      {/* Notas */}
      <section id="blogs" className="bg-white pt-5 mt-5">
        <NotasPC3Solas />
      </section>

      <div className=" d-flex justify-content-center align-items-center py-5">
        <span className="text-white">“Nuestro destino nunca es un lugar, sino una nueva forma de ver las cosas”. Henry Miller</span>
      </div>

      {/* Signos*/}
      <section>
      <SignosChangesPC />
      </section>


      {/* ecommerce */ }
      <NewServicios />
      
    </main>
  )
}
const IsMobileHome =()=>{
  return(
    <main className="bg-white">
       <header className="d-flex align-items-center justify-content-center m_header">
          <div className="w-100 h-100 d-flex justify-content-center align-items-center d-flex flex-column">
            <h1 className="m_nameLogo text-white fw-bold text-center"><img className="w-75" src={imagenesAll.h1Logo} alt="ASTROGIGIX" /></h1>
            <span className="fs-5 px-2 text-white text-center m_font_primaryss ">Astrología para ayudarnos a mirar el cielo que llevamos dentro.</span>
          </div>
       </header>
      {/* Notas */}
      <section id="blog" className="bg-white mt-5 pt-5">
        <NotasPC3Solas />
      </section>

      {/* Signos*/}
      <section className="">
        <SignosChangesMobile />
      </section>

      {/* ecommerce */ }
      <NewServiciosMobile />

    </main>
  )
}

export const NAVP =()=>{
  const navigate = useNavigate('')
  return(
    <nav className="">
      <ul>
        <li className="btn btn-primary" onClick={()=>navigate('./')}>home</li>
        <li className="btn btn-primary" onClick={()=>navigate('./login')}>Login</li>
        <li className="btn btn-primary" onClick={()=>navigate('./dashboard')}>Dashboar</li>
      </ul>
    </nav>
  )
}
// const Ecommerce = ({ title, textoInfo, price, img }) => {
//   const [verMas, setVerMas] = useState(false);
//   const limiteCaracteres = 100;

//   return (
//     <div className="bg-white p-4 rounded-lg shadow-md rounded-2 m_card_commerce d-flex flex-column justify-content-between">
//       <img src={img} alt={title} className={`w-100 rounded-2 ${verMas ? "d-none" : ""}`} />
//       <div className="mt-2">
//         <h2 className="text-black text-lg fw-bold h4">{title}</h2>
//         <p className="m_text_grey fs-6">
//           {verMas ? textoInfo : `${textoInfo.substring(0, limiteCaracteres)}...`}
//         </p>
//         {textoInfo.length > limiteCaracteres && (
//           <span 
//             onClick={() => setVerMas(!verMas)} 
//             className="m_text_blue m_text_subline mt-2"
//           >
//             {verMas ? "Leer menos" : "Leer más"}
//           </span>
//         )}
//       </div>
//       <div className="mt-4">
//         <button className="bg-blue-500 text-black px-4 py-2 rounded-2">
//           {price}
//         </button>
//       </div>
//     </div>
//   );
// };

const Ecommerce = ({ title, textoInfo, price, img, priceEuro }) => {

  const numeroWpp = "+5493512437113";

  const generarLinkWpp = (precio) => {
    const mensaje = `Hola, estoy interesada/o en la ${title} que está a ${precio}`;
    return `https://wa.me/${numeroWpp}?text=${encodeURIComponent(mensaje)}`;
  };

  return (
    <div className="d-flex w-100 justify-content-around rounded-3">
      <div className="m-4 d-flex flex-column justify-content-around">
        <h2 className="text-black text-lg fw-bold h5 fst-italic m_font_text_primary">
          {title}
        </h2>
        <p>{textoInfo}</p>
        <div className="">
          <a
            href={generarLinkWpp(price)}
            target="_blank"
            rel="noopener noreferrer"
            className="py-2 px-3 rounded-2 m_bg_green text-white"
          >
            {price} <FaWhatsapp size={30} />
          </a>
          <a
            href={generarLinkWpp(priceEuro)}
            target="_blank"
            rel="noopener noreferrer"
            className="py-2 px-3 rounded-2 mx-1 m_bg_green text-white"
          >
            {priceEuro} Exterior <FaWhatsapp size={30} />
          </a>
          <a
            href="mailto:astrogigix@gmail.com"
            className="py-2 px-3 rounded-2 m_bg_blue text-white"
          >
            astrogigix@gmail.com <IoMailOutline size={30} />
          </a>
        </div>
      </div>
      <img src={img} alt={title} className="m_w_40 rounded-4 p-2" />
    </div>
  );
};
const EcommerceInvertido = ({ title, textoInfo, price, img, priceEuro }) => {
  const numeroWpp = "+5493512437113";

  const generarLinkWpp = (precio) => {
    const mensaje = `Hola, estoy interesada/o en la ${title} que está a ${precio}`;
    return `https://wa.me/${numeroWpp}?text=${encodeURIComponent(mensaje)}`;
  };
   return (
    <div className="d-flex w-100 justify-content-around rounded-3 my-5">
      <img src={img} alt={title} className="m_w_40 rounded-4 p-2" />
      <div className="d-flex flex-column justify-content-around m-4">
        <h2 className="text-black text-lg fw-bold h5 fst-italic m_font_text_primary">
          {title}
        </h2>
        <p>{textoInfo}</p>
        <div>
          <a
            href={generarLinkWpp(price)}
            target="_blank"
            rel="noopener noreferrer"
            className="btn m_bg_green rounded-2 text-white"
          >
            {price} <FaWhatsapp size={30} />
          </a>
          <a
            href={generarLinkWpp(priceEuro)}
            target="_blank"
            rel="noopener noreferrer"
            className="btn rounded-2 mx-1 m_bg_green text-white"
          >
            {priceEuro} Exterior <FaWhatsapp size={30} />
          </a>
          <a
            href="mailto:astrogigix@gmail.com"
            className="btn rounded-2 m_bg_blue text-white"
          >
            astrogigix@gmail.com <IoMailOutline size={30} />
          </a>
        </div>
      </div>
    </div>
  );
};
const EcommerceMobile = ({ title, textoInfo, price, img, priceEuro }) => {
  const numeroWpp = "+5493512437113";

  const mensajePrecioArs = `Hola, estoy interesada/o en la "${title}" que está a ${price}`;
  const mensajePrecioEuro = `Hola, estoy interesada/o en la "${title}" que está a ${priceEuro}`;

  const linkArs = `https://wa.me/${numeroWpp.replace(/[^\d]/g, "")}?text=${encodeURIComponent(mensajePrecioArs)}`;
  const linkEuro = `https://wa.me/${numeroWpp.replace(/[^\d]/g, "")}?text=${encodeURIComponent(mensajePrecioEuro)}`;

  return (
    <div className="d-flex flex-column w-100 rounded-3">
      <img src={img} alt={title} className={`w-100 rounded-4 mt-3`} />
      <div className=" my-4 d-flex flex-column justify-content-around ">
        <h2 className="text-black text-lg fw-bold h5 fst-italic m_font_text_primary">{title}</h2>
        <p className="">{textoInfo}</p>
        <div className="">
          <a href={linkArs} target="_blank" rel="noopener noreferrer">
            <button className="rounded-2 m_bg_green">{price} <FaWhatsapp size={30} color='white' /></button>
          </a>
          <a href={linkEuro} target="_blank" rel="noopener noreferrer">
            <button className="rounded-2 mx-1 m_bg_green">{priceEuro} Exterior <FaWhatsapp size={30} color='white' /></button>
          </a>
          <button className="rounded-2 m_bg_blue">
            astrogigix@gmail.com <IoMailOutline size={30} color='white' />
          </button>
        </div>
      </div>
    </div>
  );
};


const SignosChangesPC =()=>{
  return(
    <div className="m_bg_astro pb-5">
    <div className="m_bg_astro_black d-flex flex-column w-100 justify-content-center align-items-center pb-5 ">
      <div className="text-white text-center py-4 my-5 px-3 m_w_80 ">
        <h2 className="fs-1 m_font_primary text-start pb-4">Los signos son mucho más que rasgos de personalidad.</h2>
        <p className="fs-5 mt-3  text-start">Son arquetipos que expresan distintas formas de habitar la vida. Cada uno representa una energía, una búsqueda y una manera de experimentar el mundo. La astrología nos invita a reconocer estas fuerzas en movimiento, comprender cómo se expresan en nuestra carta natal y descubrir su significado en nuestra propia historia.
        </p>
      </div>

   
    <div className="w-100 d-flex justify-content-center align-items-center pb-5">
      <div className="m_w_70 m_h100vw text-center d-flex position-relative text-white">
        
        <img className="m_img_signos" src={imagenesAll.singosBG} alt="tarot" />

        <div className="w-50 h-100 d-flex justify-content-between align-items-center">
          <div className="w-100 h-100 d-flex flex-column justify-content-center text-white text-end">
  
  {/* card 1 Aries */}
            <div className="pb-5 pe-3">
              <ComponentCardPopUp
                titleCard="Aries"
                popupTitle="Aries"
                popupText="El impulso de comenzar. Aries representa la fuerza que nos anima a dar el primer paso, abrir caminos y confiar en el deseo. Nos recuerda que no hace falta tener todo resuelto para avanzar: a veces, la vida empieza cuando nos animamos."
              />
            </div>

  {/* card 12 Tauro */}
           <div className="pt-4">
              <ComponentCardPopUp
                titleCard="Tauro"
                popupTitle="Tauro"
                popupText="La capacidad de construir y sostener. Tauro nos conecta con el cuerpo, los sentidos y aquello que crece con tiempo y dedicación. Nos enseña el valor de la presencia, la estabilidad y el disfrute de lo simple."
              />
            </div>
          </div>
          <div className="w-100 h-100 d-flex flex-column justify-content-around">

  {/* Card 2 Piscis */}
            <div className="pb-5">
              <ComponentCardPopUp
               titleCard="Piscis"
               popupTitle="Piscis"
               popupText=" La conexión con lo invisible. Piscis nos acerca a la sensibilidad, la imaginación y la empatía. Nos recuerda que no todo puede explicarse con la lógica y que también habitamos un mundo de símbolos, sueños e intuiciones."
              />
            </div>
  {/* card 11 Géminis*/}
            <div className="pt-5">
            <ComponentCardPopUp
                titleCard="Géminis"
                popupTitle="Géminis"
                popupText="La curiosidad que abre puertas. Géminis busca comprender, conectar y compartir ideas. Nos invita a aprender, preguntar y descubrir nuevas perspectivas, recordándonos que cada conversación puede transformar nuestra mirada."
              />
              
            </div>
          </div>
          <div className="w-100 h-100 d-flex flex-column justify-content-between pe-4">
  {/* card 3 Acuario*/}
            <ComponentCardPopUp
                titleCard="Acuario"
                popupTitle="Acuario"
                popupText="La mirada hacia el futuro. Acuario desafía lo establecido y abre espacio para nuevas posibilidades. Nos invita a pensar diferente, valorar la diversidad y contribuir con algo único al mundo que compartimos."
              />
           

  {/* card 10 Cáncer*/}
            <ComponentCardPopUp
                titleCard="Cáncer"
                popupTitle="Cáncer"
                popupText="El refugio del alma. Cáncer habla de pertenencia, memoria y cuidado emocional. Nos conecta con nuestras raíces y con la necesidad humana de crear espacios donde podamos sentirnos seguros y nutridos."
              />
          </div>
        </div>

        <div className="w-50 h-100 d-flex justify-content-between align-items-center">
          <div className="w-100 h-100 d-flex flex-column justify-content-between pe-4">
  {/* card 4 Capricornio*/}
              <ComponentCardPopUp
                titleCard="Capricornio"
                popupTitle="Capricornio"
                popupText="La capacidad de concretar. Capricornio representa el compromiso con aquello que queremos construir a largo plazo. Nos enseña que la perseverancia, la responsabilidad y la visión pueden convertir un sueño en realidad."
              />
            
  {/* card 9 Leo*/}
             <ComponentCardPopUp
                titleCard="Leo"
                popupTitle="Libra"
                popupText="La luz que busca expresarse. Leo representa la creatividad, la autenticidad y el deseo de brillar desde lo que somos. Nos recuerda que ocupar nuestro lugar no es egoísmo: es un acto de confianza en la propia esencia."
              />
           
          </div>
          <div className="w-100 h-100 d-flex flex-column justify-content-around">
{/* card 5 Sagitario*/}
            <div className="pb-5">
              <ComponentCardPopUp
                titleCard="Sagitario"
                popupTitle="Sagitario"
                popupText="El impulso de expandir horizontes. Sagitario busca sentido, aventura y crecimiento. Nos inspira a explorar nuevos caminos, tanto en el mundo exterior como en nuestro universo interior."
              /> 
            </div>
{/* card 8 Virgo*/}
            <div className="pt-5">
              <ComponentCardPopUp
                titleCard="Virgo"
                popupTitle="Virgo"
                popupText="El arte de mejorar lo cotidiano. Virgo observa, ordena y perfecciona. Nos enseña que los grandes cambios suelen construirse a través de pequeños gestos, atención consciente y dedicación a aquello que valoramos."
              />
              
            </div>
          </div>
          <div className="w-100 h-100 d-flex flex-column justify-content-center text-white text-start">
{/* card 6 Escorpio*/}
            <div className="pb-5">
              <ComponentCardPopUp
                titleCard="Escorpio"
                popupTitle="Escorpio"
                popupText="El poder de la transformación. Escorpio nos lleva a explorar lo profundo, aquello que necesita ser liberado para dar lugar a una nueva versión de nosotros mismos. Nos enseña que cada final contiene un comienzo."
              />
              
            </div>
{/* card 7 Libra */}
            <div className="pt-4">
              <ComponentCardPopUp
                titleCard="Libra"
                popupTitle="Libra"
                popupText="La búsqueda del equilibrio. Libra nos invita a encontrarnos con los otros, construir acuerdos y reconocer la belleza de los vínculos. Nos recuerda que toda relación es también una oportunidad para conocernos mejor."
              />
              
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
    </div>
  )
}

const SignosChangesMobile =()=>{
  return(
    <div className="m_bg_astro pb-5">
      <div className="m_bg_astro_black d-flex flex-column w-100 justify-content-center align-items-center pb-5 ">
        <div className="text-white text-center py-4 my-5 ps-3 pe-3 w-100 ">
          <h2 className="fs-1 m_font_primary text-start pb-4">Los signos son mucho más que rasgos de personalidad.</h2>
          <p className="fs-5 mt-3  text-start">Son arquetipos que expresan distintas formas de habitar la vida. Cada uno representa una energía, una búsqueda y una manera de experimentar el mundo. La astrología nos invita a reconocer estas fuerzas en movimiento, comprender cómo se expresan en nuestra carta natal y descubrir su significado en nuestra propia historia.
          </p>
        </div>
      </div>
      <div className="m_carrusell_signos_mobile">
{/*Aries*/}
      <SignosCardMobile
          imgIcon={imagenesAll.aries}
          titleCard="Aries"
          popupTitle="Aries"
          popupText="El impulso de comenzar. Aries representa la fuerza que nos anima a dar el primer paso, abrir caminos y confiar en el deseo. Nos recuerda que no hace falta tener todo resuelto para avanzar: a veces, la vida empieza cuando nos animamos."
        />
{/*Piscis*/}
        <SignosCardMobile
          imgIcon={imagenesAll.piscis}
          titleCard="Piscis"
          popupTitle="Piscis"
          popupText="La conexión con lo invisible. Piscis nos acerca a la sensibilidad, la imaginación y la empatía. Nos recuerda que no todo puede explicarse con la lógica y que también habitamos un mundo de símbolos, sueños e intuiciones."
        />
{/*Acuario*/}
        <SignosCardMobile
          imgIcon={imagenesAll.acuario}
          titleCard="Acuario"
          popupTitle="Acuario"
          popupText="La mirada hacia el futuro. Acuario desafía lo establecido y abre espacio para nuevas posibilidades. Nos invita a pensar diferente, valorar la diversidad y contribuir con algo único al mundo que compartimos."
        />
{/*Capricornio */}
        <SignosCardMobile
          imgIcon={imagenesAll.capricornio}
          titleCard="Capricornio"
          popupTitle="Capricornio"
          popupText="La capacidad de concretar. Capricornio representa el compromiso con aquello que queremos construir a largo plazo. Nos enseña que la perseverancia, la responsabilidad y la visión pueden convertir un sueño en realidad."
        />
{/*Sagitario*/}
        <SignosCardMobile
          imgIcon={imagenesAll.sagitario}
          titleCard="Sagitario"
          popupTitle="agitario"
          popupText="El impulso de expandir horizontes. Sagitario busca sentido, aventura y crecimiento. Nos inspira a explorar nuevos caminos, tanto en el mundo exterior como en nuestro universo interior."
        />
{/*Escorpion*/}
        <SignosCardMobile
          imgIcon={imagenesAll.escorpion}
          titleCard="Escorpio"
          popupTitle="Escorpio"
          popupText="El poder de la transformación. Escorpio nos lleva a explorar lo profundo, aquello que necesita ser liberado para dar lugar a una nueva versión de nosotros mismos. Nos enseña que cada final contiene un comienzo."
        />
{/*Libra*/}
        <SignosCardMobile
          imgIcon={imagenesAll.libra}
          titleCard="Libra"
          popupTitle="Libra"
          popupText="La búsqueda del equilibrio. Libra nos invita a encontrarnos con los otros, construir acuerdos y reconocer la belleza de los vínculos. Nos recuerda que toda relación es también una oportunidad para conocernos mejor."
        />
{/*Virgo*/}
        <SignosCardMobile
          imgIcon={imagenesAll.virgo}
          titleCard="Virgo"
          popupTitle="Virgo"
          popupText="El arte de mejorar lo cotidiano. Virgo observa, ordena y perfecciona. Nos enseña que los grandes cambios suelen construirse a través de pequeños gestos, atención consciente y dedicación a aquello que valoramos."
        />
{/*Leo*/}
        <SignosCardMobile
          imgIcon={imagenesAll.leo}
          titleCard="Leo"
          popupTitle="Leo"
          popupText="La luz que busca expresarse. Leo representa la creatividad, la autenticidad y el deseo de brillar desde lo que somos. Nos recuerda que ocupar nuestro lugar no es egoísmo: es un acto de confianza en la propia esencia."
        />
{/*Cancer*/}
        <SignosCardMobile
          imgIcon={imagenesAll.cancer}
          titleCard="Cáncer"
          popupTitle="Cáncer"
          popupText="El refugio del alma. Cáncer habla de pertenencia, memoria y cuidado emocional. Nos conecta con nuestras raíces y con la necesidad humana de crear espacios donde podamos sentirnos seguros y nutridos."
        />
{/*Geminis*/}
        <SignosCardMobile
          imgIcon={imagenesAll.geminis}
          titleCard="Geminis"
          popupTitle="Géminis"
          popupText="La curiosidad que abre puertas. Géminis busca comprender, conectar y compartir ideas. Nos invita a aprender, preguntar y descubrir nuevas perspectivas, recordándonos que cada conversación puede transformar nuestra mirada."
        />
{/*Tauro*/}
        <SignosCardMobile
          imgIcon={imagenesAll.tauro}
          titleCard="Taruo"
          popupTitle="Tauro"
          popupText="La capacidad de construir y sostener. Tauro nos conecta con el cuerpo, los sentidos y aquello que crece con tiempo y dedicación. Nos enseña el valor de la presencia, la estabilidad y el disfrute de lo simple."
        />
      </div>
    </div>
  )
}
 const GenerarLinkWpp = () => {
    return <a href="https://wa.me/+5493512437113?text=Hola" className="btn bg-dark text-white"><FaWhatsapp color="green" size={30}/> Consultar</a>
  };

const ComponentCardPopUp = ({ titleCard, popupTitle, popupText }) => {
  const [popUpOpen, setPopUpOpen] = useState(false);

  return (
    <div
      className="position-relative"
      onMouseEnter={() => setPopUpOpen(true)}
      onMouseLeave={() => setPopUpOpen(false)}
    >
      <div className="fs-2 fw-bold cursor-pointer">{titleCard}</div>

      {popUpOpen && (
        <div className="popup-box position-absolute top-100 start-50 translate-middle-x mt-2 p-3 bg-white text-dark shadow rounded z-3" style={{ minWidth: "300px", maxWidth: "700px" }}>
          <div className="fw-bold mb-2 text-start m_font_primaryss">{popupTitle}</div>
          <div className="text-start ">{popupText}</div>
        </div>
      )}
    </div>
  );
};
const SignosCardMobile = ({ titleCard, popupTitle, popupText, imgIcon }) => {
  const [popUpOpen, setPopUpOpen] = useState(false);

  return (
    <div className="m_signos_card bg-white rounded-3">
      <div className="d-flex justify-content-center align-items-center">
        <img className="w-75 mt-4" src={imgIcon} alt={titleCard} />
      </div>
      <div className="">
        <h3 className="fw-bold m_font_primary fst-italic mt-3 ms-4">{popupTitle}</h3>
        <p className="m_font_primary ms-4 pb-4">{popupText}</p>
      </div>
    </div>
  );
};
const NewServicios =()=>{
  return(
    <div id="serviciosDESK" className="">
      <div className="container">
        <h3 className="py-4 mt-2">✨ Lecturas base:</h3>
        <div className="row py-4 bg-gray">
          <div className="col-5  m_bg_gray-light rounded-2 pt-4">
            <h2>🌙 Carta natal</h2>
            <p>Es la configuración del cielo en el momento en que naciste. Se transforma en tu mapa y brújula para toda la vida.</p>
            <p>Te permite entender tu forma de ser, tu mundo emocional, talentos, desafíos y propósito vital. Es una lectura profunda, ideal para autoconocimiento.</p>
            < GenerarLinkWpp />
          </div>
          <div className="col-1"></div>
          <div className="col-5  m_bg_gray-light rounded-2 pt-4">
            <h2>🎂 Revolución solar</h2>
            <p>Es la carta de tu año actual (desde cumpleaños a cumpleaños).</p>
            <p>Es la carta de tu año actual (desde cumpleaños a cumpleaños).
               Muestra qué energías se activan, oportunidades, cambios y aprendizajes del momento.
              Es más orientativa y enfocada en el presente. Podés hacerla antes o después de cumplir años.</p>
              < GenerarLinkWpp />
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <h4>💫 Formato de la sesión (CN y RS) </h4>
            <p> – Encuentro de 1 hora y 30 minutos<br/>
             – Grabación de la lectura<br/>
             – Informe resumen para que pueda volver a verlo cuando quiera<br/></p>
            <p className=""><strong>Técnicas astrológicas usadas para el análisis de este formato de lecturas base:</strong> <br/>
            Carta natal, tránsitos, Carta progresada<br/>
            Revolución solar, Superposición CN y RS<br/>
            Profesiones<br/>
            Fardarias<br/>
            Ciclo de vida.<br/>
            Septenio</p>
          </div>
        </div>
      </div>
      <div className="w-100 mt-5">
            <a href="https://docs.google.com/forms/d/1YdhWkjNmOR5vmCWg6G_MvdIIk9hGwq90aYElLtBs_p4/viewform?chromeless=1&edit_requested=true" target="_blank">
            <img className="rounded-4 w-100" src={bannerDoc} alt="" />
            </a>
      </div>
      <div className="container">
        <div className="row">
          <h3 className="py-4 mt-5">Lecturas de profundización:</h3>
        </div>
        <div className="row">
          <div className="col-6 m_bg_gray-light rounded-2 pt-4">
          <h3>🌌 Carta dracónica</h3>
          <p>Es una dimensión más sutil de la carta natal.
            Nos habla del alma, de memorias más profundas y del sentido evolutivo del camino.
            Es una lectura introspectiva, ideal si ya hiciste tu carta natal y querés indagar en subtonos de orden más espiritual sobre las motivaciones internas de tu vida.</p>
            < GenerarLinkWpp />
          <h3>💫 Formato de la sesión</h3>
          <p className="">– Encuentro de 1 hora y 30 minutos<br/>
          – Grabación de la lectura<br/>
          – Informe resumen para que puedas volver a integrarlo</p>
          
        </div>
        <div className="col-6 m_bg_gray-light rounded-2 pt-4">
          <h3>🌿 Acompañamiento</h3>
          <p className="">Es un espacio de encuentros sostenidos en el tiempo, donde trabajamos en profundidad los procesos que estás atravesando, integrando la astrología como guía.
            Es vivencial, personalizado y se adapta a tu momento. </p>
            < GenerarLinkWpp />
          <h3 className="my-3">💫 Cómo funciona</h3>
          <p>– Se recomienda un mínimo de 3 encuentros<br/>
          – Cada encuentro es de una hora<br/>
          – Luego se puede continuar con encuentros mensuales<br/>
          – El proceso se va ajustando según tu necesidad</p>
          <p>Es un espacio para quienes sienten que están en un momento de transformación y quieren sostenerlo, conociendo las diversas capas de profundidad de la mano de este lenguaje, como fuente de la que brota sentido. </p>
          
      </div> 
      </div>
      <div className="w-100 mt-5">
            <a href="https://www.youtube.com/@astrogigix" target="_blank">
            <img className="rounded-4 w-100" src={bannerYT} alt="" />
            </a>
      </div>
      <div className="row ">
        <h3 className="pt-4 mt-3">✨ Lecturas aplicadas:</h3>
        <p className="pb-5">Trabajo con espacios más enfocados en situaciones concretas de la vida:</p>
        <div className="col-1"></div>
      <div className="col-3 m_bg_gray-light rounded-2 pt-4">
        <h3>🧭 Dirección astrológica</h3>
        <p>Para momentos de decisión o cambio.
        Aporta claridad, orden y perspectiva para elegir con más conciencia ✨</p>
        < GenerarLinkWpp />
      </div>
      <div className="col-1"></div>
      <div className="col-3 m_bg_gray-light rounded-2 pt-4">
        <h3>💞 Vínculos</h3>
        <p>Para comprender dinámicas en relaciones (pareja, familia, etc).
        Permite ver qué se activa en el encuentro con el otro y cómo habitarlo mejor 🌙</p>
        < GenerarLinkWpp />
      </div>
      <div className="col-1"></div>
      <div className="col-3 m_bg_gray-light rounded-2 pt-4">
        <h3>🌱 Camino vocacional</h3>
        <p>Para explorar trabajo, propósito y sentido.
          Ayuda a alinear lo que hacés con lo que sos 💫</p>
          < GenerarLinkWpp />
      </div>
      </div>
      <div className="row py-4">
        <div className="col-1"></div>
        <div className="col-3 m_bg_gray-light rounded-2 pt-4">
          <h3>💥 Son lecturas aplicadas a la vida concreta</h3>
          <p>Pensadas para acompañarte en lo que estás atravesando hoy, para trabajar temas puntuales.</p>
        </div>
        <div className="col-1"></div>
        <div className="col-3 m_bg_gray-light rounded-2 pt-4">
          <h3>💫 Formato </h3>
            <p>– Encuentros de entre 1h15 y 1h30</p>
            <p>– En algunos casos (como vínculos o vocacional) pueden ser 2 encuentros consecutivos</p>
            <p>– Incluyen grabación y material de síntesis</p>
        </div>
        <div className="col-1"></div>
        <div className="col-3 m_bg_gray-light rounded-2 pt-4">
          <h3>Técnicas astrológicas usadas para el análisis de este formato de lecturas aplicadas:</h3>
            <p>Carta natal, tránsitos, Carta progresada<br/>
            Carta dracónica, <br/>
            Revolución solar, Profesiones, Fardarias<br/>
            Ciclo de vida.<br/>
            Carta de sinastría<br/>
            Carta compuesta técnica de puntos medios</p>

        </div>
      </div>
      </div>
    </div>
  )
}
const NewServiciosMobile =()=>{
  return(
    <div id="lectura" className="">
      <div className="container">
        <h3 className="py-4 mt-2">✨ Lecturas base:</h3>
        <div className="row py-4 bg-gray">
          <div className="m_bg_gray-light rounded-2 pt-4">
            <h2>🌙 Carta natal</h2>
            <p>Es la configuración del cielo en el momento en que naciste. Se transforma en tu mapa y brújula para toda la vida.</p>
            <p>Te permite entender tu forma de ser, tu mundo emocional, talentos, desafíos y propósito vital. Es una lectura profunda, ideal para autoconocimiento.</p>
          </div>
          <div className="m_bg_gray-light rounded-2 pt-4">
            <h2>🎂 Revolución solar</h2>
            <p>Es la carta de tu año actual (desde cumpleaños a cumpleaños).</p>
            <p>Es la carta de tu año actual (desde cumpleaños a cumpleaños).
               Muestra qué energías se activan, oportunidades, cambios y aprendizajes del momento.
              Es más orientativa y enfocada en el presente. Podés hacerla antes o después de cumplir años.</p>
          </div>
        </div>
        <div className="row">
          <div className="">
            <h4>💫 Formato de la sesión (CN y RS) </h4>
            <p> – Encuentro de 1 hora y 30 minutos<br/>
             – Grabación de la lectura<br/>
             – Informe resumen para que pueda volver a verlo cuando quiera<br/></p>
            <p className=""><strong>Técnicas astrológicas usadas para el análisis de este formato de lecturas base:</strong> <br/>
            Carta natal, tránsitos, Carta progresada<br/>
            Revolución solar, Superposición CN y RS<br/>
            Profesiones<br/>
            Fardarias<br/>
            Ciclo de vida.<br/>
            Septenio</p>
            < GenerarLinkWpp />
          </div>
          <div className="w-100 mt-5">
            <a href="https://docs.google.com/forms/d/1YdhWkjNmOR5vmCWg6G_MvdIIk9hGwq90aYElLtBs_p4/viewform?chromeless=1&edit_requested=true" target="_blank">
            <img className="rounded-4 w-100" src={bannerDoc} alt="" />
            </a>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row">
          <h3 className="py-4 mt-5">Lecturas de profundización:</h3>
        </div>
        <div className="row">
          <div className="m_bg_gray-light rounded-2 pt-4">
          <h3>🌌 Carta dracónica</h3>
          <p>Es una dimensión más sutil de la carta natal.
            Nos habla del alma, de memorias más profundas y del sentido evolutivo del camino.
            Es una lectura introspectiva, ideal si ya hiciste tu carta natal y querés indagar en subtonos de orden más espiritual sobre las motivaciones internas de tu vida.</p>
          <h3>💫 Formato de la sesión</h3>
          <p className="">– Encuentro de 1 hora y 30 minutos<br/>
          – Grabación de la lectura<br/>
          – Informe resumen para que puedas volver a integrarlo</p>
          < GenerarLinkWpp />
        </div>
        
        <div className="m_bg_gray-light rounded-2 pt-4">
          <h3>🌿 Acompañamiento</h3>
          <p className="">Es un espacio de encuentros sostenidos en el tiempo, donde trabajamos en profundidad los procesos que estás atravesando, integrando la astrología como guía.
            Es vivencial, personalizado y se adapta a tu momento. </p>
            < GenerarLinkWpp />
          <h3>💫 Cómo funciona</h3>
          <p>– Se recomienda un mínimo de 3 encuentros<br/>
          – Cada encuentro es de una hora<br/>
          – Luego se puede continuar con encuentros mensuales<br/>
          – El proceso se va ajustando según tu necesidad</p>
          <p>Es un espacio para quienes sienten que están en un momento de transformación y quieren sostenerlo, conociendo las diversas capas de profundidad de la mano de este lenguaje, como fuente de la que brota sentido. </p>
          < GenerarLinkWpp />
      </div> 
      <div className="w-100 mt-5">
            <a href="https://www.youtube.com/@astrogigix" target="_blank">
            <img className="rounded-4 w-100" src={bannerYT} alt="" />
            </a>
      </div>
      </div>
      <div className="row ">
        <h3 className="pt-4 mt-3">✨ Lecturas aplicadas:</h3>
        <p className="pb-5">Trabajo con espacios más enfocados en situaciones concretas de la vida:</p>

      <div className="m_bg_gray-light rounded-2 pt-4">
        <h3>🧭 Dirección astrológica</h3>
        <p>Para momentos de decisión o cambio.
        Aporta claridad, orden y perspectiva para elegir con más conciencia ✨</p>
        < GenerarLinkWpp />
      </div>
      <div className="m_bg_gray-light rounded-2 pt-4">
        <h3>💞 Vínculos</h3>
        <p>Para comprender dinámicas en relaciones (pareja, familia, etc).
        Permite ver qué se activa en el encuentro con el otro y cómo habitarlo mejor 🌙</p>
        < GenerarLinkWpp />
      </div>

      <div className="m_bg_gray-light rounded-2 pt-4">
        <h3>🌱 Camino vocacional</h3>
        <p>Para explorar trabajo, propósito y sentido.
          Ayuda a alinear lo que hacés con lo que sos 💫</p>
          < GenerarLinkWpp />
      </div>
      </div>
      <div className="row py-4">

        <div className="m_bg_gray-light rounded-2 pt-4">
          <h3>💥 Son lecturas aplicadas a la vida concreta</h3>
          <p>Pensadas para acompañarte en lo que estás atravesando hoy, para trabajar temas puntuales.</p>
        </div>

        <div className="m_bg_gray-light rounded-2 pt-4">
          <h3>💫 Formato </h3>
            <p>– Encuentros de entre 1h15 y 1h30</p>
            <p>– En algunos casos (como vínculos o vocacional) pueden ser 2 encuentros consecutivos</p>
            <p>– Incluyen grabación y material de síntesis</p>
        </div>
        <div className="m_bg_gray-light rounded-2 pt-4">
          <h3>Técnicas astrológicas usadas para el análisis de este formato de lecturas aplicadas:</h3>
            <p>Carta natal, tránsitos, Carta progresada<br/>
            Carta dracónica, <br/>
            Revolución solar, Profesiones, Fardarias<br/>
            Ciclo de vida.<br/>
            Carta de sinastría<br/>
            Carta compuesta técnica de puntos medios</p>

        </div>
      </div>
      </div>
    </div>
  )
}